module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', [_c('form', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-md-center"
  }, [_c('v-avatar', {
    attrs: {
      "size": "200"
    }
  }, [_c('img', {
    attrs: {
      "src": this.photoURL,
      "alt": "avatar"
    }
  })])], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-md-center"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "selectedFile",
      "accept": "image/jpeg, image/png"
    },
    on: {
      "change": _vm.imageSelected
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Select a new profile image",
      "onclick": "document.getElementById('selectedFile').click();"
    }
  })])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "name",
      "label": "Name",
      "id": "name",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "bio",
      "label": "Tell us a little about yourself",
      "id": "bio",
      "type": "bio",
      "required": ""
    },
    model: {
      value: (_vm.bio),
      callback: function($$v) {
        _vm.bio = $$v
      },
      expression: "bio"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "title",
      "label": "Job Title",
      "id": "title",
      "type": "title",
      "required": ""
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "org",
      "label": "Organization",
      "id": "org",
      "type": "org",
      "required": ""
    },
    model: {
      value: (_vm.organization),
      callback: function($$v) {
        _vm.organization = $$v
      },
      expression: "organization"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "round": "",
      "color": "primary",
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.confirmChanges
    }
  }, [_vm._v("Confirm Changes")])], 1)])], 1)], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3da67c75","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/EditProfile.vue
// module id = 87
// module chunks = 7